export const ID_PREFIX = '__waveform__list__item__';
export const ERROR_MESSAGE = 'Error in loading audio ';
export const PROCESSING_MESSAGE = 'Processing audio';

export enum CallType {
  SELF_CALL = 'SELF_CALL'
}

export enum CustomerCalledSourceType {
  SELF_CALL_EXPERIMENT = 'SELF_CALL_EXPERIMENT'
}

export enum RecordingFileStatus {
  IN_PROGRESS = 'IN_PROGRESS',
  RECON = 'RECON',
  SUCCESS = 'SUCCESS'
}
